import {
  setAiOnboardingInprogress,
  setIsAiOnboardingCompleted,
  setAiOnboardingNextStep,
  setAiOnboardingStepCompleted,
  setIsAiOnboardingIntegrationConnected,
  setIsOnboardingMetricsActive,
  setIsTrackerClassesConfigured,
} from '../../store/reducers/userSlice';
import store from '../../store/store';
import { fetchAppInit } from './app-init';
import update_all_shop_stats_api_call from './dashboard/update_all_shop_stats_api_call';

export default async function onboarding_state_updates(
  shopId: number,
  stats: any
) {
  // if user skipped the onboarding without shop registration
  if (!shopId) {
    store.dispatch(setIsAiOnboardingCompleted(false));
    store.dispatch(setAiOnboardingInprogress(true));
    return;
  }

  // Persisted completion flag (redux-persist whitelist ['user']). When a user
  // has finished the streamlined account-type onboarding, a stale shop-scoped
  // backend step (e.g. an active shop still at old-wizard step 2/3/4 that never
  // got an explicit completion write) must NOT flip them back into onboarding.
  // Only the re-trap branches below honour this; the "mark complete" branch is
  // left unguarded so backend completion can still promote a user to done.
  const hasCompletedOnboarding =
    store.getState().user?.ai_onboarding?.is_ai_onboarding_completed === true;

  if (shopId && stats && stats?.additional_stats) {
    const additional_stats = stats?.additional_stats;

    // setting ai tracker configuration status
    store.dispatch(
      setIsTrackerClassesConfigured(
        additional_stats?.is_tracker_classes_configured ?? false
      )
    );

    // setting current onboarding step
    if (
      !additional_stats?.dashboard_onboarding_current_step ||
      additional_stats?.dashboard_onboarding_current_step === 0
    ) {
      store.dispatch(setAiOnboardingNextStep(1));
    } else {
      store.dispatch(
        setAiOnboardingNextStep(
          additional_stats?.dashboard_onboarding_current_step
        )
      );
    }

    // config: show metrics step vs brand step (default false = show brand step)
    store.dispatch(
      setIsOnboardingMetricsActive(
        additional_stats?.is_onboarding_metrics_active === true
      )
    );

    // when tracker classes are configured and onboarding is not complete (old users)
    if (
      additional_stats?.is_tracker_classes_configured &&
      !additional_stats?.is_dashboard_onboarding_complete
    ) {
      const sendOnboardingStatus = await update_all_shop_stats_api_call(
        3,
        true
      );

      if (sendOnboardingStatus) {
        fetchAppInit(); // Initialize the app
      }
    }

    // When all onboarding steps are completed
    if (additional_stats?.is_dashboard_onboarding_complete) {
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 1, isCompleted: true })
      );
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 2, isCompleted: true })
      );
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 3, isCompleted: true })
      );
      store.dispatch(setIsAiOnboardingCompleted(true));
      store.dispatch(setAiOnboardingInprogress(false));
      store.dispatch(setIsAiOnboardingIntegrationConnected(true));
    }

    // When current onboarding step is 2
    if (
      !hasCompletedOnboarding &&
      !additional_stats?.is_dashboard_onboarding_complete &&
      additional_stats?.dashboard_onboarding_current_step === 2
    ) {
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 1, isCompleted: true })
      );
      store.dispatch(setIsAiOnboardingCompleted(false));
      store.dispatch(setAiOnboardingInprogress(true));
    }

    // When current onboarding step is 3
    if (
      !hasCompletedOnboarding &&
      !additional_stats?.is_dashboard_onboarding_complete &&
      additional_stats?.dashboard_onboarding_current_step === 3
    ) {
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 1, isCompleted: true })
      );
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 2, isCompleted: true })
      );
      store.dispatch(setIsAiOnboardingCompleted(false));
      store.dispatch(setAiOnboardingInprogress(true));
      store.dispatch(setIsAiOnboardingIntegrationConnected(true));
    }

    // When current onboarding step is 4 (user completed step 3 - metrics or brand)
    if (
      !hasCompletedOnboarding &&
      !additional_stats?.is_dashboard_onboarding_complete &&
      additional_stats?.dashboard_onboarding_current_step === 4
    ) {
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 1, isCompleted: true })
      );
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 2, isCompleted: true })
      );
      store.dispatch(
        setAiOnboardingStepCompleted({ stepNumber: 3, isCompleted: true })
      );
      store.dispatch(setIsAiOnboardingCompleted(false));
      store.dispatch(setAiOnboardingInprogress(true));
      store.dispatch(setIsAiOnboardingIntegrationConnected(true));
    }
  }
}
